import { gql } from "@apollo/client"

export const GET_NEAREST_REGION_ID = gql`
  query getNearestRegionID($location: geography) {
    nearest_region_v2(args: { location: $location }) {
      region_id
    }
  }
`
